var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 12px;\n'], ['\n  color: ', ';\n  font-size: 12px;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { materialColors } from 'styled-material';
export var ErrorMessage = styled.div(_templateObject, materialColors['red-500']);
//# sourceMappingURL=error-message.js.map
